module.exports = __webpack_public_path__ + "static/media/jetpack.a1a1da9c.svg";